import { Checkbox, Field, Label } from "@headlessui/react";
import { IconCheckmark } from "@hawkins/assets";
import { ComponentProps, ReactNode } from "react";
import cx from "classnames";

export const CheckboxInput = ({
  label,
  invalid,
  inputProps,
}: {
  label: ReactNode;
  invalid: boolean;
  inputProps: ComponentProps<typeof Checkbox>;
}) => (
  <Field as="div" className="flex items-center gap-2">
    <Checkbox
      {...inputProps}
      className={cx(
        "w-4 h-4 rounded-[4px] p-[2px] bg-brand-cream/10 focus:ring-0 flex items-center justify-center group transition-colors",
        invalid && "!bg-brand-red/15",
        inputProps.className
      )}
    >
      <IconCheckmark className="w-4 h-4 text-brand-cream transition-opacity opacity-0 group-aria-checked:opacity-100" />
    </Checkbox>
    <Label
      className={cx(
        "text-body-small transition-colors",
        invalid && "text-brand-red"
      )}
    >
      {label}
    </Label>
  </Field>
);
